//#region IMPORT
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import M_M_RNM_BASIC_01 from './M_RNM_BASIC_01';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
//#endregion

function M_M_RNM_BASIC_01F() {
  const dispatch = useDispatch();

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = async () => {
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(NavBarInfoActions.setTitleName('위험성평가하기'));
    } catch (e) {
      console.error('Init Error:', e);
    }
  };

  return (
    <div className="wrap">
      <M_M_RNM_BASIC_01 />
    </div>
  );
}

export default M_M_RNM_BASIC_01F;
